import { doc, getDoc, setDoc, updateDoc, serverTimestamp, onSnapshot } from 'firebase/firestore';
import { db } from '../../src/firebase';

export interface SystemSettings {
    trialModeEnabled: boolean;
    updatedAt?: any;
}

const SETTINGS_DOC_ID = 'system';
const SETTINGS_COLLECTION = 'settings';

export const getSystemSettings = async (): Promise<SystemSettings> => {
    const docRef = doc(db, SETTINGS_COLLECTION, SETTINGS_DOC_ID);
    const snap = await getDoc(docRef);

    if (snap.exists()) {
        return snap.data() as SystemSettings;
    }

    // Default settings
    return {
        trialModeEnabled: false
    };
};

export const updateSystemSettings = async (settings: Partial<SystemSettings>) => {
    const docRef = doc(db, SETTINGS_COLLECTION, SETTINGS_DOC_ID);
    await setDoc(docRef, {
        ...settings,
        updatedAt: serverTimestamp()
    }, { merge: true });
};

export const subscribeToSystemSettings = (callback: (settings: SystemSettings) => void) => {
    const docRef = doc(db, SETTINGS_COLLECTION, SETTINGS_DOC_ID);
    return onSnapshot(docRef, (snap) => {
        if (snap.exists()) {
            callback(snap.data() as SystemSettings);
        } else {
            callback({ trialModeEnabled: false });
        }
    });
};
